import React, { useState, useContext, useRef } from 'react';
import './MonitoredIndividualSelection.css';
import Modal from '../Modal/Modal';
import SimpleMIUserCard from '../SimpleMIUserCard/SimpleMIUserCard';
import SelectionList from '../SelectionList/SelectionList';
import ActionButtons from '../ActionButtons/ActionButtons';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function MonitoredIndividualSelection({ hide }) {
  const environmentContext = useContext(EnvironmentContext);
  const [selectedMonitoredIndividual, setSelectedMonitoredIndividual] = useState(selectedMonitoredIndividual);
  const [modalShouldExit, setModalShouldExit] = useState(false);
  const { activeUser: user } = environmentContext;

  const modalRef = useRef(null);
  const selectionList = useRef(null);
  const actionButtons = useRef(null);

  if (logComponent('MonitoredIndividualSelection')) { console.debug('MonitoredIndividualSelection rendered'); }


  const setModalRef = (el) => {
    if (logComponent('MonitoredIndividualSelection')) { console.debug('MonitoredIndividualSelection setModalRef'); }
    modalRef.current = el;
  }

  const updateSelectedMonitoredIndividual = (miUser) => {
    if (logComponent('MonitoredIndividualSelection')) { console.debug('MonitoredIndividualSelection updateSelectedMonitoredIndividual'); }
    setSelectedMonitoredIndividual(miUser.MonitoredIndividual);
  }

  const selectMonitoredIndividual = () => {
    if (logComponent('MonitoredIndividualSelection')) { console.debug('MonitoredIndividualSelection selectMonitoredIndividual'); }
    const { setSelectedMonitoredIndividual } = environmentContext;

    setSelectedMonitoredIndividual(selectedMonitoredIndividual);
    startModalExit();
  }

  const startModalExit = () => {
    if (logComponent('MonitoredIndividualSelection')) { console.debug('MonitoredIndividualSelection startModalExit'); }
    setModalShouldExit(true);
  }

  const focusSelectionListFirstItem = () => {
    if (logComponent('MonitoredIndividualSelection')) { console.debug('MonitoredIndividualSelection focusSelectionListFirstItem'); }
    selectionList.current.focus();
  }

  const focusActionButtonsLastItem = () => {
    if (logComponent('MonitoredIndividualSelection')) { console.debug('MonitoredIndividualSelection focusActionButtonsLastItem'); }
    actionButtons.current.focus();
  }

  const handleKeyDown = (e) => {
    if (logComponent('MonitoredIndividualSelection')) { console.debug('MonitoredIndividualSelection handleKeyDown'); }
    if (e.key === 'Escape') hide(true);
  }

  return (
    <Modal isVisible={true} shouldExit={modalShouldExit} hide={hide} ref={setModalRef}>
      <div
        className="Monitored-Individual-Selection"
        onKeyDown={handleKeyDown}>
        <h3 className="Monitored-Individual-Selection__heading">Individual selection</h3>
        <span
          tabIndex="0"
          className="Monitored-Individual-Selection__focus-control"
          onFocus={focusActionButtonsLastItem} />
        <SelectionList
          ref={selectionList}
          items={user.monitoredIndividualUsers}
          itemComponent={SimpleMIUserCard}
          itemComponentPropName="miUser"
          itemComponentOtherProps={{
            nameOnly: true
          }}
          itemKeyField="monitoredIndividualId"
          initialSelection={selectedMonitoredIndividual}
          onSelect={updateSelectedMonitoredIndividual} />
        <ActionButtons
          ref={actionButtons}
          mainAction={selectMonitoredIndividual}
          mainActionText="Select individual"
          cancel={startModalExit}
          cancelText="Cancel" />
      </div>
      <span
        tabIndex="0"
        className="Monitored-Individual-Selection__focus-control"
        onFocus={focusSelectionListFirstItem}></span>
    </Modal>
  );
}